import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-tb-purchase',
  templateUrl: './tb-purchase.component.html',
  styleUrls: ['./../turbo-ballots-runner.component.scss', './tb-purchase.component.scss'],
})
export class TBPurchaseComponent implements OnInit {

  @Output() vote: EventEmitter<any> = new EventEmitter();

  @Input() ballotObservable: BehaviorSubject<any>;
  @Input() matrixObservable: BehaviorSubject<any>;
  @Input() ballotVotedObservable: BehaviorSubject<any>;
  @Input() ballotSkippedObservable: BehaviorSubject<any>;

  freezed = false;
  selectedValue: Array<number> = new Array<number>();
  totalVotes: number = null;
  votes: Array<any> = null;
  cardsSize = 'default';
  arePlayersOdd = false;
  animateSelected = false;

  constructor() { }

  ngOnInit() {
    this.ballotObservable.subscribe(ballot => this.ballotLoaded(ballot));
    this.matrixObservable.subscribe(matrix => this.matrixLoaded(matrix));
    this.ballotVotedObservable.subscribe(votedBallot => this.ballotVoted(votedBallot));
    this.ballotSkippedObservable.subscribe(skipped => this.ballotSkipped(skipped));
  }

  ballotLoaded(ballot) {
    this.setCardsSize();
    this.setArePlayersOdd();
    this.unfreeze();
  }

  setCardsSize() {
    if (!!this.ballotObservable.value && this.ballotObservable.value.players) {
      this.cardsSize = this.ballotObservable.value.players.length > 2 ? 'small' : 'default';
    }
  }

  setArePlayersOdd() {
    if (!!this.ballotObservable.value && this.ballotObservable.value.players) {
      this.arePlayersOdd = (this.ballotObservable.value.players.length % 2 !== 0);
    }
  }

  matrixLoaded(matrix) { }

  ballotVoted(votedBallot) {
    if (!!votedBallot) {
      this.totalVotes = votedBallot.total_votes;
      this.votes = votedBallot.votes;
    }
  }

  ballotSkipped(skipped) {
    // Reset values
    if (!!this.selectedValue) {
      this.selectedValue.splice(0, this.selectedValue.length); // Reset value
    }
    this.totalVotes = null;
    this.votes = null;
  }

  toggleSelection(playerId) {
    if (this.isFreezed()) { return; }

    const index = this.selectedValue.indexOf(playerId);

    if (index === -1) {
      this.selectedValue.push(playerId);
    } else {
      this.selectedValue.splice(index, 1);
    }

    if (this.selectedValue.length === parseInt(this.matrixObservable.value[0], 10) ) {
      this.emitVote(this.selectedValue);
    }

    // Trigger animation
    this.animateSelected = true;
    const t = setTimeout(() => {
      this.animateSelected = false;
      clearTimeout(t);
    }, 2000);
  }

  isSelected(playerId) {
    if (!!this.selectedValue === false) { return false; }
    const index = this.selectedValue.indexOf(playerId);
    return index > -1;
  }

  emitVote(selectedValue) {
    this.freeze();
    this.vote.emit(selectedValue);
  }

  freeze() {
    this.freezed = true;
  }

  unfreeze() {
    this.freezed = false;
  }

  isFreezed() {
    return this.freezed;
  }


}
